import { useDefaultLocalizationTexts } from '@mews/framework/localization';
import { ThemeVariant as OptimusThemeVariant, WithChildren } from '@optimus-web/core';
import { OptimusProvider } from '@optimus-web/theme';
import { getThemeOverrides } from '../../theme/theme';

export type ThemeVariant = 'Light' | 'Dark';

export interface ThemeWrapperProps extends WithChildren {
    primaryColor: string | null;
    variant: ThemeVariant;
}

export const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children, primaryColor, variant }) => {
    const designSystemThemeVariant: OptimusThemeVariant = variant === 'Light' ? 'b2bLight' : 'b2bDark';
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const overrides = primaryColor ? getThemeOverrides(primaryColor) : undefined;
    const localButtonOverrides =
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        primaryColor && overrides
            ? {
                  backgroundInteractivePrimaryDefault: primaryColor,
                  backgroundInteractivePrimaryActive: overrides.decisions.interactive.primary.active,
                  backgroundInteractivePrimaryHover: overrides.decisions.interactive.primary.hover,
                  borderInteractiveFocus: overrides?.decisions.borderColor.semantic.primary,
                  borderInteractivePrimaryDefault: overrides?.decisions.borderColor.semantic.primary,
                  textInteractivePrimaryDefault: overrides.decisions.interactive.primary.default,
                  borderInteractivePrimaryHover: overrides.decisions.interactive.primary.hover,
                  borderInteractivePrimaryActive: overrides.decisions.interactive.primary.active,
              }
            : undefined;

    return (
        <OptimusProvider
            tokenOverrides={localButtonOverrides}
            themeVariant={designSystemThemeVariant}
            localizationTexts={useDefaultLocalizationTexts()}
        >
            {children}
        </OptimusProvider>
    );
};
